import React, { useState, useEffect } from 'react';
import api from '../api';
import TopNav from '../components/TopNav';
import BottomNav from '../components/BottomNav';

const OrderHistory = ({ deviceId }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrders();
  }, [deviceId]);

  const loadOrders = async () => {
    try {
      const data = await api.getOrders(deviceId);
      setOrders(data);
    } catch (error) {
      console.error('Error loading orders:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TopNav deviceId={deviceId} />
        <p style={{ color: '#4C956C' }}>LOADING...</p>
        <BottomNav currentPath="/account" />
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FEFEE3', paddingBottom: '100px' }}>
      <TopNav deviceId={deviceId} currentPath="/account" />
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
        <h1 style={{ fontSize: '24px', color: '#2C6E49', marginBottom: '30px', textAlign: 'center' }}>[ ORDER HISTORY ]</h1>
        
        {orders.length === 0 ? (
          <div className="retro-card" style={{ background: '#FFF', padding: '60px 20px', textAlign: 'center' }}>
            <p style={{ fontSize: '18px', color: '#4C956C' }}>NO ORDERS YET</p>
          </div>
        ) : (
          <div>
            {orders.map((order) => (
              <div key={order._id} className="retro-card" style={{ background: '#FFF', padding: '20px', marginBottom: '15px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                  <div>
                    <p style={{ fontSize: '12px', color: '#2C6E49', fontWeight: 'bold' }}>ORDER #{order._id.slice(-8)}</p>
                    <p style={{ fontSize: '10px', color: '#4C956C' }}>
                      {new Date(order.created_at).toLocaleDateString()}
                    </p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#2C2C2C' }}>${order.total.toFixed(2)}</p>
                    <span style={{ 
                      background: order.status === 'processing' ? '#FFC857' : order.status === 'shipped' ? '#2C6E49' : '#4C956C',
                      color: '#FFF',
                      padding: '3px 10px',
                      fontSize: '9px',
                      fontWeight: 'bold'
                    }}>
                      {order.status.toUpperCase()}
                    </span>
                  </div>
                </div>
                
                <div style={{ paddingTop: '15px', borderTop: '1px solid #F7F6D8' }}>
                  {order.items.map((item) => (
                    <p key={`${order._id}-${item.name}-${item.color}-${item.size}`} style={{ fontSize: '11px', color: '#666', marginBottom: '5px' }}>
                      {item.name} ({item.color}, {item.size}) x{item.quantity}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <BottomNav currentPath="/account" />
    </div>
  );
};

export default OrderHistory;
